export default __webpack_public_path__ + "static/media/codewar.8cd7f0c1.jpg";